import { BILL_ACTIONS } from '../../consts/actions';
import { ReactComponent as IconDuplicate } from '../../../../../../assets/svg/shared/icon-duplicate-action.svg';
import { ReactComponent as IconDelete } from '../../../../../../assets/icons/svg/shared/ic-shared-trash.svg';
import { ReactComponent as IconPreview } from '../../../../../../assets/icons/svg/shared/ic-shared-eye-opened.svg';
import { ReactComponent as IconPayNow } from '../../../../../../assets/svg/shared/icon-pay-now.svg';
import { ReactComponent as IconMarkAsPaid } from '../../../../../../assets/svg/shared/icon-mark-as-paid.svg';
import { API_INVOICES_PAYMENT_METHODS } from '../../../../../Invoices/InvoiceHub/consts/consts';
import { ReactComponent as IconPaymentApp } from '../../../../../../assets/svg/invoices-icons/icon-pm-payment-app.svg';
import { ReactComponent as IconPaymentCash } from '../../../../../../assets/svg/invoices-icons/icon-pm-cash.svg';
import { ReactComponent as IconPaymentCheck } from '../../../../../../assets/svg/invoices-icons/icon-pm-check.svg';
import { ReactComponent as IconPaymentACH } from '../../../../../../assets/svg/invoices-icons/icon-pm-bank-transfer.svg';
import { ReactComponent as IconPaymentOnlinePlatform } from '../../../../../../assets/svg/invoices-icons/icon-pm-paypal.svg';
import { ReactComponent as IconPaymentOther } from '../../../../../../assets/svg/invoices-icons/icon-pm-crypto.svg';

export enum CUSTOM_MENU_COMPONENTS {
  REMINDER = 'REMINDER',
}

export const AVAILABLE_BILL_MODALS = {
  NONE: 'NONE',
  SPINNER: 'SPINNER',
  ERROR: 'ERROR',
  ACTIONS_MENU: 'ACTION_MENU',
  MARK_AS_PAID: 'MARK_AS_PAID',
  MARK_AS_UNPAID: 'MARK_AS_UNPAID',
  MARK_AS_CANCELED: 'MARK_AS_CANCELED',
  CANCEL_DETAILS_REQUEST: 'CANCEL_DETAILS_REQUEST',
};

const mapActionToIcon = {
  [BILL_ACTIONS.PREVIEW]: IconPreview,
  [BILL_ACTIONS.DUPLICATE]: IconDuplicate,
  [BILL_ACTIONS.PAY_NOW]: IconPayNow,
  [BILL_ACTIONS.MARK_AS_PAID]: IconMarkAsPaid,
  [BILL_ACTIONS.CANCEL]: IconDelete,
};

export const PENDING_BILLS_MENU_ACTIONS = [
  {
    title: 'BILL_PAY.BILL_ACTIONS_SUB_MENU.PREVIEW',
    SVGComponent: mapActionToIcon[BILL_ACTIONS.PREVIEW],
    SVGColor: 'stroke-bw08',
    name: BILL_ACTIONS.PREVIEW,
    testId: 'previewAction',
  },
  {
    title: 'BILL_PAY.BILL_ACTIONS_SUB_MENU.DUPLICATE',
    SVGComponent: mapActionToIcon[BILL_ACTIONS.DUPLICATE],
    SVGColor: 'stroke-bw08',
    name: BILL_ACTIONS.DUPLICATE,
    testId: 'duplicateAction',
    isCrudOperation: true,
  },
  {
    title: '',
    SVGComponent: '',
    name: '',
    testId: 'subItemSplitter',
  },
  {
    title: 'BILL_PAY.BILL_ACTIONS_SUB_MENU.PAY_NOW',
    SVGComponent: mapActionToIcon[BILL_ACTIONS.PAY_NOW],
    name: BILL_ACTIONS.PAY_NOW,
    textColor: 'text-bw08',
    SVGColor: 'stroke-bw08',
    arrowColor: 'stroke-bw08',
    testId: 'payNowAction',
    isCrudOperation: true,
  },
  {
    title: 'BILL_PAY.BILL_ACTIONS_SUB_MENU.MARK_AS_PAID',
    SVGComponent: mapActionToIcon[BILL_ACTIONS.MARK_AS_PAID],
    name: BILL_ACTIONS.MARK_AS_PAID,
    textColor: 'text-bw08',
    SVGColor: 'stroke-bw08',
    arrowColor: 'stroke-bw08',
    testId: 'markAsPaidAction',
    isCrudOperation: true,
  },
  {
    title: '',
    SVGComponent: '',
    name: '',
    testId: 'subItemSplitter',
  },
  {
    component: CUSTOM_MENU_COMPONENTS.REMINDER,
    name: BILL_ACTIONS.REMINDER_ON,
    testId: 'reminder',
  },
  {
    title: '',
    SVGComponent: '',
    name: '',
    testId: 'subItemSplitter',
  },
  {
    title: 'BILL_PAY.BILL_ACTIONS_SUB_MENU.DELETE',
    SVGComponent: mapActionToIcon[BILL_ACTIONS.CANCEL],
    name: BILL_ACTIONS.CANCEL,
    textColor: 'text-red02',
    SVGColor: 'stroke-red02 text-red02',
    arrowColor: 'stroke-red02 text-red02',
    testId: 'cancelInvoiceAction',
    isCrudOperation: true,
  },
];

export const PAID_BILLS_MENU_ACTIONS = [
  {
    title: 'BILL_PAY.BILL_ACTIONS_SUB_MENU.PREVIEW',
    SVGComponent: mapActionToIcon[BILL_ACTIONS.PREVIEW],
    SVGColor: 'stroke-bw08',
    name: BILL_ACTIONS.PREVIEW,
    testId: 'previewAction',
  },
  {
    title: 'BILL_PAY.BILL_ACTIONS_SUB_MENU.DUPLICATE',
    SVGComponent: mapActionToIcon[BILL_ACTIONS.DUPLICATE],
    SVGColor: 'stroke-bw08',
    name: BILL_ACTIONS.DUPLICATE,
    testId: 'duplicateAction',
    isCrudOperation: true,
  },
  {
    title: '',
    SVGComponent: '',
    name: '',
    testId: 'subItemSplitter',
  },
  {
    title: 'BILL_PAY.BILL_ACTIONS_SUB_MENU.DELETE',
    SVGComponent: mapActionToIcon[BILL_ACTIONS.CANCEL],
    name: BILL_ACTIONS.CANCEL,
    textColor: 'text-red02',
    SVGColor: 'stroke-red02 text-red02',
    arrowColor: 'text-red02',
    testId: 'cancelInvoiceAction',
    isCrudOperation: true,
  },
];

type billPaymentMethodOptions = {
  [key: string]: string
}
export const BILL_API_INVOICES_PAYMENT_METHODS: billPaymentMethodOptions = {
  PAYMENT_APP: 'PAYMENT_APP',
  CASH: 'CASH',
  CHECK: 'CHECK',
  ACH: 'ACH',
  ONLINE_PLATFORM: 'ONLINE_PLATFORM',
  WIRE: 'WIRE',
  OTHER: 'OTHER',
};

export const PAYMENT_METHODS_DROPDOWN_OPTIONS = [
  {
    value: BILL_API_INVOICES_PAYMENT_METHODS.PAYMENT_APP,
    icon: IconPaymentApp,
    text: 'PAYMENT_METHODS.PAYMENT_APP',
  },
  {
    value: BILL_API_INVOICES_PAYMENT_METHODS.CASH,
    icon: IconPaymentCash,
    text: 'PAYMENT_METHODS.CASH',
  },
  {
    value: BILL_API_INVOICES_PAYMENT_METHODS.CHECK,
    icon: IconPaymentCheck,
    text: 'PAYMENT_METHODS.CHECK',
  },
  {
    value: BILL_API_INVOICES_PAYMENT_METHODS.ACH,
    icon: IconPaymentACH,
    text: 'PAYMENT_METHODS.ACH',
  },
  {
    value: BILL_API_INVOICES_PAYMENT_METHODS.ONLINE_PLATFORM,
    icon: IconPaymentOnlinePlatform,
    text: 'PAYMENT_METHODS.ONLINE_PLATFORM',
  },
  {
    value: API_INVOICES_PAYMENT_METHODS.OTHER,
    icon: IconPaymentOther,
    text: 'PAYMENT_METHODS.OTHER',
  },
];

export const AWAITING_DETAILS_BILLS_MENU_ACTIONS = [
  {
    title: 'BILL_PAY.BILL_ACTIONS_SUB_MENU.PREVIEW',
    SVGComponent: mapActionToIcon[BILL_ACTIONS.PREVIEW],
    SVGColor: 'stroke-bw08',
    name: BILL_ACTIONS.PREVIEW,
    testId: 'previewAction',
  },
  {
    title: 'BILL_PAY.BILL_ACTIONS_SUB_MENU.DUPLICATE',
    SVGComponent: mapActionToIcon[BILL_ACTIONS.DUPLICATE],
    SVGColor: 'stroke-bw08',
    name: BILL_ACTIONS.DUPLICATE,
    testId: 'duplicateAction',
    isCrudOperation: true,
  },
  {
    title: '',
    SVGComponent: '',
    name: '',
    testId: 'subItemSplitter',
  },
  {
    component: CUSTOM_MENU_COMPONENTS.REMINDER,
    name: BILL_ACTIONS.REMINDER_ON,
    testId: 'reminder',
  },
  {
    title: '',
    SVGComponent: '',
    name: '',
    testId: 'subItemSplitter',
  },
  {
    title: 'BILL_PAY.BILL_ACTIONS_SUB_MENU.DELETE',
    SVGComponent: mapActionToIcon[BILL_ACTIONS.CANCEL],
    name: BILL_ACTIONS.CANCEL,
    textColor: 'text-red02',
    SVGColor: 'stroke-red02 text-red02',
    arrowColor: 'stroke-red02 text-red02',
    testId: 'cancelInvoiceAction',
    isCrudOperation: true,
  },
];
